"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseSearch = parseSearch;
exports.stringifySearch = stringifySearch;
function parseSearch(search) {
    if (!search || !/^\?/.test(search))
        return {};
    const rawSearch = search.replace(/^\?/, '').split('&');
    return rawSearch.reduce((r, s) => {
        const [key, value] = s.split('=');
        r[key] = value;
        return r;
    }, {});
}
function stringifySearch(searchObj) {
    if (typeof searchObj !== 'object') {
        return '';
    }
    const kv = [];
    Object.keys(searchObj).forEach(key => {
        // TODO url encode ?
        kv.push(`${key}=${searchObj[key]}`);
    });
    return `?${kv.join('&')}`;
}
//# sourceMappingURL=search.js.map